import { render, staticRenderFns } from "./CardStyle.vue?vue&type=template&id=f5b62396&scoped=true&"
import script from "./CardStyle.vue?vue&type=script&lang=ts&"
export * from "./CardStyle.vue?vue&type=script&lang=ts&"
import style0 from "./CardStyle.vue?vue&type=style&index=0&id=f5b62396&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b62396",
  null
  
)

export default component.exports